"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCAL_STORAGE_URL_PATH = void 0;
var LOCAL_STORAGE_URL_PATH = 'submitted_no_availability_support_ticket/';
exports.LOCAL_STORAGE_URL_PATH = LOCAL_STORAGE_URL_PATH;